import { Dispatch } from "redux";
import { getCIQTokenFailure, getCIQTokenRequest, getCIQTokenSuccess } from "src/store/actions/creditIQ";
import { ActionType } from "src/store/dataService/actions/utils/actionCreator";
import { getFrom } from "./shared/osfetch";
import { findRoute } from "./util";

const getToken = async (
    next: Dispatch,
    { payload: { uuid, vin, afterFetch } }: ActionType<typeof getCIQTokenRequest>
) => {
    const response = await getFrom(`/deals/${uuid}/credit_iq/application/${vin}/token`, next);

    if (response.ok) {
        next(getCIQTokenSuccess(vin, await response.json()));
    } else {
        next(getCIQTokenFailure(vin));
    }

    if (afterFetch) afterFetch();
};

const routes = {
    [getCIQTokenRequest.type]: getToken,
};

export default (next: Dispatch, action: any) => findRoute(routes)(next, action);
